// assets
import { IconKey, IconUserPlus } from '@tabler/icons';

// constant
const icons = {
  IconKey,
  IconUserPlus
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const userType = sessionStorage.getItem('UserType');

const Pages = {
  id: 'authentication',
  title: 'Onboarding',
  type: 'group',
  display_id: 'B',
  icon: icons.IconUserPlus,
  children: [
    {
      id: 'agentonboarding',
      title: 'Agent Onboarding',
      type: 'item',
      display_id: 9,
      url: '/Admin/agentonboarding',
      breadcrumbs: true
    },
    {
      id: 'approval',
      title: 'Agent Request',
      type: 'item',
      display_id: 11,
      url: '/Admin/Requests',
      icon: icons.IconFile,
      breadcrumbs: false
    },
    {
      id: 'dsonboarding',
      title: 'DS Onboarding',
      type: 'item',
      display_id: 10,
      url: '/Admin/dsonboarding',
      breadcrumbs: false
    },
    {
      id: 's',
      title: 'Ds Request',
      type: 'item',
      display_id: 12,
      url: '/Admin/ops/DsApproval',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    {
      id: 'fos_onboarding',
      title: 'FOS Onboarding',
      type: 'item',
      display_id: 110,
      url: '/Admin/fosonboarding',
      breadcrumbs: false
    },
    {
      id: 'fos_request',
      title: 'FOS Request',
      type: 'item',
      display_id: 116,
      url: '/Admin/fosrequest',
      breadcrumbs: false
    },

    {
      id: 'agentdeboarding',
      title: 'Deboarding Request',
      type: 'item',
      display_id: 37,
      url: '/Admin/deboarding',
      breadcrumbs: false
    },
    {
      id: 'deboarding_list',
      title: 'Deboarding List',
      type: 'item',
      display_id: 85,
      url: '/Admin/deboarding_list',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    {
      id: 'payment_status',
      title: 'Payment Status',
      type: 'item',
      display_id: 22,
      url: '/Admin/payment_status',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    {
      id: 'video_kyc',
      title: 'Video Kyc',
      type: 'item',
      display_id: 26,
      url: '/Admin/VideoKyc',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    {
      id: 'payment_request',
      title: 'Payment request',
      type: 'item',
      display_id: 23,
      url: '/Admin/payment_request',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },

    {
      id: 'kycupload',
      title: 'KYC Upload',
      type: 'item',
      display_id: 27,
      url: '/Admin/kycupload',
      breadcrumbs: false
    },
    {
      id: 'Csp_Code_Activation',
      title: userType === 'ft' ? 'Code Activation' : 'Code Create & Activation',
      type: 'item',
      display_id: 24,
      url: '/Admin/Csp_Code_Activation',
      breadcrumbs: false
    },
    {
      id: 'Terminal_mapping',
      title: 'Terminal Mapping',
      type: 'item',
      display_id: 25,
      url: '/Admin/Terminal_mapping',
      breadcrumbs: false
    },
    // {
    //   id: 'wallet',
    //   title: 'Wallet',
    //   type: 'item',
    //   display_id: 28,
    //   url: '/Admin/wallet',
    //   breadcrumbs: false
    // },
    // {
    //   id: 'wallet_topup',
    //   title: 'DS Topup Request',
    //   type: 'item',
    //   display_id: 29,
    //   url: '/Admin/ds_wallet_topup_request',
    //   breadcrumbs: false
    // },
    // {
    //   id: 'csp_mapping',
    //   title: 'CSP Mapping Request',
    //   type: 'item',
    //   display_id: 33,
    //   url: '/Admin/csp_mapping_request',
    //   breadcrumbs: false
    // },
    // {
    //   id: 'hardware_request',
    //   title: 'Hardware Request',
    //   type: 'item',
    //   display_id: 35,
    //   url: '/Admin/hardware_request',
    //   breadcrumbs: false
    // },
    // {
    //   id: 'bankdeposit_request',
    //   title: 'Bank Deposit Request',
    //   type: 'item',
    //   display_id: 36,
    //   url: '/Admin/bankdeposit_request',
    //   breadcrumbs: false
    // },
    {
      id: 'ds_payment_link',
      title: 'DS Payment Link',
      type: 'item',
      display_id: 101,
      url: '/Admin/ds_payment_link',
      breadcrumbs: false
    },
    {
      id: 'aec_list',
      title: 'AEC List',
      type: 'item',
      display_id: 106,
      url: '/Admin/aec_list',
      breadcrumbs: false
    }
  ].filter(Boolean)
};

export default Pages;
